<template>
  <div class="buyGold">
      <Header /> 
      <div class="container">
        <div class="banner-ad">
          <ads-91 :unitIdentifier="LeadIdentifier" />
        </div>
        <div class="middle-panel">
          <div class="gold-item">
            <GoldDetails :goldPrice="gold.current_price" />
          </div>
          <div class="gold-item gold-content">
            <UserGoldDetail />
          </div>
        </div>
       
        <div class="checkbox">
          <div class="Amount-box">
            <label class="radio-group">
              <input type="radio" v-model="amountType" value="gram" @change="amountTypehandler()" />
              {{$t('buyingrams')}}
              <span class="circle"></span>
            </label>
             <label class="radio-group">
              <input type="radio" v-model="amountType" value="amount" @change="amountTypehandler()" />
              {{$t('buyinamount')}}
              <span class="circle"></span>
            </label> 
          </div>
          <div class="amount-text">
            <input
              type="number"
              @input="getGoldConversionResult"
              :placeholder="symbol"
              v-model="amount"
            />
            <span>
              {{roundDown(goldConversionResult, 4)}} {{unit}}
              <!-- <i class="fa fa-info-circle" aria-hidden="true"></i> -->
            </span>
          </div>
          <div class="include_gst">
            <span class="gst">{{$t('include_gst')}}</span>
            <span class="gst">{{$t('total_amount')}}: ₹{{gstIncludedPrice}}</span>
          </div>
          <Button @goBack="buyGold()" :btn_txt="$t('buygold')"></Button>
        </div>
         <div class="scroll-content">
        <QA />
      </div> 
      </div>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GoldDetails from "../components/GoldDetails";
import UserGoldDetail from "../components/UserGoldDetail";
import Button from "../components/Button";
import { SessionHelper } from "../utils/session"
import {
  getPriceByWeight,
  getWeightByPrice,
  getAmountIncludedGst,
  toaster,
  roundDown,
  roundOff,
  getDiscount,
  isAmountUpto2decimal,
  isGoldUpto4decimal
} from "../utils/helper";
import QA from "../components/QA";

export default {
  name: "BuyGold",
  components: {
    Header,
    GoldDetails,
    Button,
    UserGoldDetail,
    QA
  },
  computed: {
    ...mapGetters(["gold"])
  },
  props: {
    color: {
      type: String,
      default: "#55491d"
    }
  },

  data() {
    return {
      amount: "",
      amountType: "amount",
      goldConversionResult: 0,
      gstIncludedPrice: 0,
      unit: "gram",
      symbol: "₹ xxxx",
      loading: false,
      LeadIdentifier: "d1dfe02c-8086-4b5f-99eb-760329aa826e",
    };
  },

  methods: {
    roundOff,
    roundDown,
    amountTypehandler(e) {
      const { amountType } = this;
      this.amount = "";
      this.gstIncludedPrice = 0;
      this.goldConversionResult = 0;
      if (amountType === "gram") {
        this.unit = "Rs";
        this.symbol = "1 gram";
      } else {
        this.unit = "gram";
        this.symbol = "₹ xxxx";
      }
    },

    getGoldConversionResult(event) {
      const { amountType } = this;
      const { value } = event.target;
      const { current_price } = this.buyPrice;
      if (amountType === "amount") {
        this.goldConversionResult = roundDown(
          getWeightByPrice(current_price, value),
          4
        );
        let data = roundOff(getAmountIncludedGst(current_price), 2);
        this.finalGoldAmount = roundDown(value / data, 4);
        this.gstIncludedPrice = roundOff(
          Number(value) - getDiscount(value, 3),
          2
        );
      } else {
        this.goldConversionResult = getPriceByWeight(current_price, value);
        this.gstIncludedPrice = roundOff(
          getAmountIncludedGst(this.goldConversionResult),
          2
        );
      }
    },

    buyGold() {
      SessionHelper.refereshJwtToken()
      const {
        amount,
        amountType,
        goldConversionResult,
        gstIncludedPrice
      } = this;
      if (amountType === "gram") {
        if (amount <= 0 || amount > 10 || !isGoldUpto4decimal(amount)) {
          toaster(this, this.$t("fillupto4decimal"), "top-left", 3000);
          return;
        }
        if (roundOff(goldConversionResult, 2) < 1) {
          toaster(this, this.$t("lessthan1"), "top-left", 3000);
          return;
        }
      } else {
        if (amount < 1 || amount > 10000 || !isAmountUpto2decimal(amount)) {
          toaster(this, this.$t("fillamountupto2decimal"), "top-left", 3000);
          return;
        }
      }
      const { rate_id, current_price } = this.buyPrice;
      const goldAmount =
        amountType === "gram" ? Number(amount) : this.finalGoldAmount;
      this.loading = !this.loading;
      this.$store
        .dispatch({
          type: "buyVerification",
          payload: {
            rate_id: rate_id,
            buy_price:
              amountType === "gram" ? this.gstIncludedPrice : Number(amount),
            gold_rate: current_price,
            gold_amount: Number(goldAmount),
            cal_type: amountType === "gram" ? "amount" : "price"
          }
        })
        .then(data => {
          this.loading = !this.loading;
          this.$router.push({
            name: "Payment",
            params: data.data.data
          });
        })
        .catch(err => {
          this.loading = !this.loading;
          toaster(this, this.$t("somethingwentwrong"), "top-left", 3000);
        });
    }
  },

  mounted() {
    this.$store
      .dispatch({ type: "buyPrice" })
      .then(data => {
        this.buyPrice = data.data.data;
      })
      .catch(err => {
        toaster(this, this.$t("somethingwentwrong"), "top-left", 3000);
        this.$router.push("/");
      });
  }
};
</script>